var map = {
	"./da-DK.json": 80195,
	"./de-DE.json": 79277,
	"./en-US.json": 31684,
	"./es-419.json": 90155,
	"./es-ES.json": 89895,
	"./fi-FI.json": 1253,
	"./fr-FR.json": 29487,
	"./id-ID.json": 51413,
	"./it-IT.json": 4885,
	"./ja-JP.json": 88666,
	"./ko-KR.json": 7012,
	"./pt-BR.json": 31183,
	"./pt-PT.json": 8587,
	"./ro-RO.json": 91573,
	"./ru-RU.json": 65653,
	"./tl-PH.json": 64699,
	"./tr-TR.json": 75279,
	"./vi-VN.json": 14532,
	"./zh-CN.json": 95472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14385;